import React, { useMemo } from 'react';
import { SectionStylesSetters } from 'components/Section/useStyles';
import BackgroundImage from 'components/Toolbar/Controls/BackgroundImage';
import BackgroundColor from 'components/Toolbar/Controls/FillColor';
import ControlGroup from 'components/Toolbar/Shared/ControlGroup';
import { BrandColorsList, SectionStylesMap } from 'models';
import { colorFromSource } from 'utils/converters';
import { brandColorGradientFromSource } from 'utils/converters/colorGradient';
import { intlGet } from 'utils/intlGet';
import BaseToolbar from '../BaseToolbar';
import css from './styles.module.scss';

type Props = {
  name: string;
  styles: SectionStylesMap;
  stylesSetters: SectionStylesSetters;
  colors: BrandColorsList;
};

const Section: React.FunctionComponent<Props> = (props) => {
  const { name, styles, stylesSetters, colors } = props;

  const backgroundColor = useMemo(
    () => colorFromSource(colors, styles.get('backgroundColor'), styles.get('backgroundColorTint')),
    [colors, styles],
  );
  const backgroundGradient = useMemo(
    () => brandColorGradientFromSource(colors, styles.get('backgroundGradient')),
    [colors, styles],
  );

  return (
    <BaseToolbar title={intlGet('EditorToolbar.Asset', 'Section')} dataTestId='section-baseToolbar'>
      <ControlGroup dataTestId='controlGroup0'>
        <div className={css.SectionName} data-testid='section-name'>{name}</div>
      </ControlGroup>
      <ControlGroup dataTestId='controlGroup1'>
        <BackgroundColor
          activeColor={backgroundColor}
          toggleColor={stylesSetters.backgroundColor}
          gradient={backgroundGradient}
          toggleGradient={stylesSetters.backgroundGradient}
          opacity={styles.get('backgroundColorOpacity')}
          toggleOpacity={stylesSetters.backgroundColorOpacity}
          dataTestId='section-backgroundColor'
        />
        {stylesSetters.backgroundImage && <BackgroundImage
          backgroundImage={styles.get('backgroundImage')}
          toggleBackgroundImage={stylesSetters.backgroundImage}
          dataTestId='section-backgroundImage'
        />}
      </ControlGroup>
    </BaseToolbar>
  );
};

export default Section;
